export enum ComposantCardDisableCause {
  espace = 'Espace',
  hierarchie = 'Hierarchie'
}
